import orderUtil from "./Utils/orderUtil.js";
const lang = orderUtil.getParam("lang");
const Css = {
  lvsEditor(editorWidth){
    return {
      width: editorWidth + "px",
      userSelect:"none",
    }
  },
  editorArea(editorWidth){
    return {
      width: editorWidth + "px",
      height: orderUtil.patternEditorHeight + "px",
      backgroundColor: "#121212",
    }
  },
  pcBtnArea:{
    // height:"40px",
    float: "left",
  },
  pcBtnArea2:{
    // height:"40px",
    float: "left",
    width:"100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "83px",
  },
  createBtn:{
    // width:"260px",
    padding: "0 20px",
    height:"40px",
    lineHeight:"40px",
    backgroundColor:"#ff2d89",
    textAlign:"center",
    borderRadius:"4px",
    color:"#fff",
    userSelect:"none",
    margin:"0 26px 0 0",
    float:"left",
    cursor:"pointer"
  },
  playBtn:{
    // width:"340px",
    padding: "0 20px",
    height:"40px",
    lineHeight:"40px",
    backgroundColor:"#ff2d89",
    textAlign:"center",
    borderRadius:"4px",
    color:"#fff",
    userSelect:"none",
    margin: "0 26px 0 0",
    float:"left",
    cursor:"pointer"
  },
  playBtn2:{
    // width:"300px",
    padding: "0 20px",
    height:"40px",
    lineHeight:"40px",
    backgroundColor:"#efbfbd",
    textAlign:"center",
    borderRadius:"4px",
    color:"#fff",
    userSelect:"none",
    cursor:"pointer",
    display:"inline-block",
    marginRight:"20px"
  },
  playPatternBtn:{
    width: "260px",
    height: "40px",
    lineHeight: "40px",
    backgroundColor: "#ff2d89",
    textAlign: "center",
    borderRadius: "4px",
    color: "#fff",
    userSelect: "none",
    float: "left",
    marginRight: "26px",
    cursor: "pointer",
  },
  
  ///手机端
  lvsMoPattern:{
    width: "100%",
    height: "0.7rem",
    float: "left"
  },
  syncBtn:{
    color:"#fff",
    borderRadius: "0.04rem",
    fontSize: "0.2rem",
    height: "0.5rem",
    lineHeight: "0.5rem",
    backgroundColor: "#ff2d89",
    display: "inline-block",
    padding: "0 0.2rem",
    textAlign: "center",
    float: "left",
    userSelect:"none",
    textDecoration: "none",
    margin: "0 0 0 0.2rem"
  },
  syncBtn2:{
    color: "#ccc",
    borderRadius: "0.04rem",
    fontSize: "0.2rem",
    height: "0.5rem",
    lineHeight: "0.5rem",
    backgroundColor: "#1D1D1D",
    display: "inline-block",
    padding: "0 0.2rem",
    textAlign: "center",
    float: "left",
    userSelect:"none",
    margin: "0 0 0 0.2rem"
  },
  syncBtn3(){
    if (lang==='ru') {
      return {
        width:"100%",
        height:"40px",
        lineHeight:"40px",
        backgroundColor:"#efbfbd",
        textAlign:"center",
        borderRadius:"15px",
        color:"#fff",
        userSelect:"none",
        margin:"0 auto",
        fontSize:"12px",
        textDecoration: "none",
        display: "block"
      }
    } else {
      return {
        // width:"260px",
        width:"100%",
        // padding: "0 20px",
        height:"40px",
        lineHeight:"40px",
        backgroundColor:"#efbfbd",
        textAlign:"center",
        borderRadius:"15px",
        color:"#fff",
        userSelect:"none",
        margin:"0 auto",
        fontSize:"14px",
        textDecoration: "none",
        display: "block"
      }
    }
    
    
  },
  discBtn:{
    color: "#ccc",
    borderRadius: "0.04rem",
    fontSize: "0.2rem",
    height: "0.5rem",
    lineHeight: "0.5rem",
    backgroundColor: "#1D1D1D",
    display: "inline-block",
    padding: "0 0.2rem",
    textAlign: "center",
    float: "left",
    userSelect:"none",
    margin: "0 0 0 0.2rem"
  },
  endBtn:{
    color:"#ff2d89",
    borderRadius: "0.04rem",
    fontSize: "0.2rem",
    height: "0.5rem",
    lineHeight: "0.5rem",
    // backgroundColor: "#ff2d89",
    backgroundColor: "#1D1D1D",
    width: "0.8rem",
    textAlign: "center",
    float: "left",
    userSelect:"none",
    marginLeft: "0.2rem"
  },
  syncAgain:{
    color:"#fff",
    borderRadius: "0.04rem",
    fontSize: "0.2rem",
    height: "0.5rem",
    lineHeight: "0.5rem",
    backgroundColor: "#ff2d89",
    textAlign: "center",
    padding: "0 0.2rem",
    float: "left",
    userSelect:"none",
    textDecoration: "none",
    marginLeft: "0.2rem"
  }
}
export default Css;